import DocumentModal from './document.modal.model';

export default class documentModalFormController {
	constructor(
		$scope,
		$stateParams,
		$timeout,
		TemplateImpressionService,
		MassiaApplicationService,
		DocumentsTypesService,
		DocumentsService,
		CodeAutomatiqueService
	) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.loading = false;
		this.type = 'info';
		this.timeout = $timeout;
		this.templateImpressionService = TemplateImpressionService;
		this.value = 0;
		this.cancelButton = 'IMPRESSION.CANCEL';
		this.codeExist = null;
		this.massiaAppService = MassiaApplicationService;
		this.DocumentsTypesService = DocumentsTypesService;
		this.DocumentsService = DocumentsService;
		this.CodeAutomatiqueService = CodeAutomatiqueService;
		this.afficheCode = true;
	}

	async $onInit() {
		this.$scope.$broadcast('DocumentModalValidator');

		this.form = {
			data: this.resolve && this.resolve.data && this.resolve.data.id ? new DocumentModal(this.resolve.data) : new DocumentModal(),
			file: {}
		};

		await this.checkCodeAuto();

		this.form.data.isValid();

		this.loadTypes().then((data) => {
			this.types = data;
			const application = this.massiaAppService.getApplication();
			if (application === 'performance') {
				const type = this.types.find(function (e) {
					return e.code === 'S_PERFORMANCE';
				});
				this.form.data.idType = type.id;
				this.form.data.libelleType = type.libelle;
			} else {
				const typeIndex = this.types.findIndex(function (e) {
					return e.code === 'S_PERFORMANCE';
				});
				if (typeIndex >= 0) {
					this.types.splice(typeIndex, 1);
				}
			}

			if (this.typeSelected) {
				const type = this.types.find((e) => e.code == this.typeSelected);
				this.form.data.idType = type.id;
				this.form.data.libelleType = type.libelle;
				this.isDisabledType = true;
			} else {
				this.isDisabledType = false;
			}
		});
	}

	async loadTypes() {
		try {
			const types = await this.DocumentsTypesService.getAll();
			return types;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	removeUnnecessaryDomain(domains) {
		for (let i = 0; i < domains.length; i++) {
			if (!domains[i].droits || domains[i].droits.print == undefined) {
				//if(domains[i].niveauMax < 31){//SP : NON, prendre si droit sur impression
				domains.splice(i, 1);
				i--;
			}
		}
	}

	isValidCodeForm() {
		return (!this.estCodeAuto && !this.codeExist && this.form.data.code !== '' && this.form.data.code) || this.estCodeAuto;
	}

	async ok() {
		this.loading = true;
		this.fileInfoOpen = false;

		if (this.form.data.isValid() && this.isValidCodeForm) {
			this.value = 50;
			this.progress = 'Envoi en cours';
			try {
				const that = this;
				await this.DocumentsService.onFileSelect([this.form.file], 0, this.form.data.code, this.form.data.idType, function (data) {
					that.form.data.id = data;
					that.form.data.sizeCoverted = that.form.data.size / 100 + 'ko';
					that.value = 100;
					that.type = 'success';
					that.progress = 'Upload réussi';
					that.fileInfoOpen = true;

					that.modalInstance.close(that.form.data);
				});
			} catch (err) {
				this.value = 100;
				this.type = 'danger';
				this.progress = err.data;
			}
			this.cancelButton = 'Fermer';
		} else {
			this.loading = false;
		}
	}

	cancel() {
		this.$scope.$parent.$dismiss();
	}

	change(event) {
		const fileInfo = event.target.files[0];
		this.form.file = fileInfo;
		const file = this.getFileAndExtension(fileInfo.name);
		this.form.data.libelle = file.libelle;
		this.form.data.extension = file.extension;
		this.form.data.size = fileInfo.size;
		this.form.data.sizeCoverted = fileInfo.size / 100 + 'ko';
		this.form.data.dateCreation = fileInfo.lastModified;
		this.fileInfoOpen = true;
		this.loading = false;
	}

	getFileAndExtension(fileName) {
		let match = fileName.match(/(.*)\.([^.]*)$/);
		if (!match) return { libelle: fileName, extension: '' };

		return { libelle: match[1], extension: match[2] };
	}

	openFileUploader() {
		document.getElementById('file-upload').click();
	}
	async checkCodeAuto() {
		try {
			const code = await this.CodeAutomatiqueService.getCodeAutomatique(this.massiaAppService.getApplication());
			const res = code.find((x) => x.domaineCode === 'Documents');
			this.estCodeAuto = res.estCodeAutomatique;
			this.form.data.estCodeAuto = this.estCodeAuto;
			if (this.estCodeAuto) {
				this.afficheCode = res.estCodeAffiche;
			} else {
				this.afficheCode = true;
			}
		} catch (err) {
			console.error(err);
		}
	}
	async checkCodeUnicity(code) {
		this.codeExist = null;
		if (code) {
			this.loading = true;
			try {
				if (code.match(/^[a-zA-Z0-9_|]*$/)) {
					this.codeExist = await this.DocumentsService.codeExists(code);
				}
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.loading = false;
			}
		}
	}

	checkform(form) {
		console.log(form);
	}
}

documentModalFormController.$inject = [
	'$scope',
	'$stateParams',
	'$timeout',
	'TemplateImpressionService',
	'MassiaApplicationService',
	'DocumentsTypesService',
	'DocumentsService',
	'CodeAutomatiqueService'
];
